import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { first } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ChallanService } from '../../../../services/challan-services.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

@Component({
  selector: 'app-full-payment',
  templateUrl: './full-payment.component.html',
  styleUrls: ['./full-payment.component.scss']
})
export class FullPaymentComponent implements OnInit {

  public fullPaymentForm: FormGroup;
  public isSubmitted: boolean = false;
  filteredProgramme: any = [];
  filteredModeOfPayment: any = [];
  programmeData: any;
  paymentDate: any;
  modeOfPaymentData: any;
  amount: any;
  referenceNo: any;
  accountNo: any;
  paymentCheckBox: any;
  public isReference: boolean = true;


  public appId: any;
  public programId: any;

  public todayDate: Date;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private challanMIService: ChallanService,
    private messageService: MessageService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService
  ) { }

  ngOnInit(): void {
    this.appId = this.route.snapshot.params.id;
    this.programId = this.route.snapshot.params.pId;
    console.log('iddd', this.route.snapshot.params.id);

    this.fullPaymentForm = this.fb.group({
      paymentDate: ['', Validators.required],
      modeOfPayment: ['', Validators.required],
      amount: ['', Validators.required],
      referenceNumber: [''],
      accountNumber: ['', Validators.required],
    })
    this.todayDate = new Date();
    console.log(this.todayDate, 'todayDate')
  }

  get f() {
    return this.fullPaymentForm.controls;
  }


  modeOfPayment: any = [
    {
      mode: "Cash",
      id: 1
    },
    {
      mode: "Online",
      id: 2
    },
    {
      mode: "RTGS",
      id: 3
    },
    {
      mode: "NEFT",
      id: 4
    }
  ]

  // filterProgramme(event: any) {
  //   const filtered: any[] = [];
  //   const query = event.query;
  //   for (let i = 0; i < this.selectProgramme.length; i++) {
  //     const selectProgramme = this.selectProgramme[i];
  //     if (selectProgramme.program.toLowerCase().indexOf(query.toLowerCase()) == 0) {
  //       filtered.push(selectProgramme);
  //     }
  //   }
  //   this.filteredProgramme = filtered;
  // }

  filterModeOfPayment(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.modeOfPayment.length; i++) {
      const modeOfPayment = this.modeOfPayment[i];
      if (modeOfPayment.mode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(modeOfPayment);
      }
    }
    this.filteredModeOfPayment = filtered;
  }

  change(){
    if(this.modeOfPaymentData?.mode == "Cash"){
      this.isReference = false;
      // this.fullPaymentForm.get('referenceNumber').clearAsyncValidators();
      // this.fullPaymentForm.get('referenceNumber').updateValueAndValidity;
    }else{
      this.isReference = true;
      // this.fullPaymentForm.get('referenceNumber').setValidators([Validators.required]);
      // this.fullPaymentForm.get('referenceNumber').updateValueAndValidity;
    }
  }

  submitPaymentDetails() {
    console.log(this.paymentCheckBox, "paymentCheckBox");
    console.log(this.fullPaymentForm.value, "form value");
    if(this.fullPaymentForm.valid && this.paymentCheckBox){
      console.log(this.fullPaymentForm.value, "form value");
      let val = this.fullPaymentForm.value;

      const finalData = {
        appId: this.appId,
        virtualID: this.isReference == true ? val?.referenceNumber : 'Cash',
        // virtualID: val?.referenceNumber,
        amountPaid: val.amount,
        paymentMode: val.modeOfPayment.mode,
        accountNo: JSON.stringify(val.accountNumber),
        paymentDate: val.paymentDate,
        progId: parseInt(this.programId)
      }

      const reqBody = finalData;
      this.insertChallanData(reqBody)


      this.fullPaymentForm.reset();
      this.router.navigateByUrl('/challan/mi-challan')
    }
    else{
      this.isSubmitted = true;
      console.log("Invalid Form");
    }
  }

  insertChallanData(reqBody){
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
    this.loader.start();
    this.challanMIService
    .insertChallanData(reqBody)
    .pipe(first())
      .subscribe({
        next: (data) => {
          
          this.activityRecordService.activityRecord(mobile, 'Full Payment Challan Data Inserted', reqBody?.appId, new Date(), 'Success');
          this.loader.close();
          console.log('insertChallan', data);
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: data,
          });
        },
        error: (err) => {
          this.activityRecordService.activityRecord(mobile, 'Full Payment Challan Data Inserted', reqBody?.appId, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data Error! Estimation Not Added',
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Estimation Added Successfully',
        //   });
        // },
      });
  }

}
